import LoadingView from "./LoadingView";

export { LoadingView };

export default LoadingView;
